"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getNumberValue = function (data) {
    if (typeof data === 'number') {
        return data;
    }
    if (data && typeof data.value === 'number') {
        return data.value;
    }
    return undefined;
};
exports.default = getNumberValue;
//# sourceMappingURL=getNumberValue.js.map